<template>
  <div>
    <keep-alive>
      <component :is="orgInformComponent"
                 ref="method"
                 @org-inform-view="orgInformView"
                 :param="param"
      >
      </component>
    </keep-alive>
  </div>
</template>

<script>
import InformList from './InformList'
import OrgInformAdd from './OrgInformAdd'
import OrgInformDetail from './OrgInformDetail'

export default {
  name: 'OrgInformIndex',
  components: {
    'inform-list': InformList,
    'org-inform-detail': OrgInformDetail,
    'org-inform-add': OrgInformAdd
  },
  data () {
    return {
      showDetail: false,
      param: '',
      orgInformComponent: 'inform-list'
    }
  },
  methods: {
    orgInformView (view, flag) {
      this.orgInformComponent = view
      if (flag) {
        this.$nextTick(() => {
          this.param = flag
          this.$refs['method'].changeEvent(flag)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
